import { GET_OPERATOR_OPEN_RUN_MACHINES } from 'lib/api/queries';

// The lookup is optional, so a slow response must not hold up clock-out.
export const OPEN_RUNS_LOOKUP_TIMEOUT_MS = 5000;

const lookupOtherApmMachines = async (client, personId, currentMachineRef) => {
  try {
    const { data } = await client.query({
      query: GET_OPERATOR_OPEN_RUN_MACHINES,
      // apollo-link-rest puts path args in verbatim, so an ERP id with `/`,
      // `?`, `#` or `%` would miss the route without encoding.
      variables: { personId: encodeURIComponent(String(personId)) },
      fetchPolicy: 'network-only',
    });
    return (data?.operatorOpenRunMachines || []).filter((machine) => {
      return (
        machine.isApm &&
        String(machine.machineRef) !== String(currentMachineRef)
      );
    });
  } catch (err) {
    return [];
  }
};

/**
 * APM machines (other than this one) the operator is still signed into. Their
 * production has no labor ticket until submitted, so the open-ticket check at
 * clock-out can't see it. Any failure, or no answer within
 * OPEN_RUNS_LOOKUP_TIMEOUT_MS, resolves to [] so this lookup can never block
 * clock-out.
 */
export const fetchOtherApmMachines = (client, personId, currentMachineRef) => {
  let timer;
  const timeout = new Promise((resolve) => {
    timer = setTimeout(() => {
      return resolve([]);
    }, OPEN_RUNS_LOOKUP_TIMEOUT_MS);
  });
  return Promise.race([
    lookupOtherApmMachines(client, personId, currentMachineRef),
    timeout,
  ]).finally(() => {
    clearTimeout(timer);
  });
};
